module.exports = __webpack_public_path__ + "../resources/img/ic_arrow_left.22e82f7a.svg";